module.exports = __webpack_public_path__ + "media/images/information/other-05641904c930dcb57cb4cbc8d8e1e552.svg";